





























































































































































import {
  defineComponent,
  reactive,
  computed,
  ref,
  watch,
  Ref,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';

import { useRouter, useFormat } from 'vivat';

import useAuth from '@/useAuth';
import usePayment from '@/usePayment';

import getDelivery from '@/gql/delivery/getDelivery.gql';
import createDelivery from '@/gql/delivery/createDelivery.gql';
import updateDelivery from '@/gql/delivery/updateDelivery.gql';

import ItemOrder from '@/components/Delivery/ItemOrder.vue';
import GroupAddressEditor from '@/components/LocationAddress/GroupAddressEditor.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonTimePicker from '@/components/CommonTimePicker.vue';
import CommonAreaCodeSelector from '@/components/Setting/CommonAreaCodeSelector.vue';

const CommonFormWithDeliveryEditor = defineComponent({
  components: {
    ItemOrder,
    GroupAddressEditor,
    StickyFooterActionBar,
    CommonModalWithPreset,
    CommonTimePicker,
    CommonAreaCodeSelector,
    PrettyCheck,
  },
  props: {
    edit: {
      default() { return false; },
    },
  },
  setup(props: any) {
    const { me } = useAuth();
    const { th: paymentMethodTH, en: paymentMethodEN } = usePayment();
    const toDecimalFormat = (string: any) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const NOW = new Date();
    const client = reactive({
      id: -1,
      name: '',
      orderDate: NOW,
      orderTime: NOW.toTimeString().substr(0, 8),
      contact: '',
      tel: '',
      orderNo: '',
      customerCode: '',
      lat: '0.0000',
      long: '0.0000',
      deliveryDiscount: '0',
      targetDate: NOW,
      address: {
        address: '',
        province: {
          id: '',
        },
        district: {
          id: '',
        },
        subdistrict: {
          id: '',
        },
        zipcode: '',
        telephone: '',
      },
      senderCode: '',
      senderName: '',
      senderAddress: {
        address: '',
        province: {
          id: '',
        },
        district: {
          id: '',
        },
        subdistrict: {
          id: '',
        },
        zipcode: '',
      },
      area: null,
      price: '',
      payment: '',
      notation: '',
      items: [
        {
          id: -1,
          name: '',
          code: '',
          width: '',
          length: '',
          height: '',
          count: '',
          weight: '',
          unitsPerCount: '1',
          unit: '',
          deliveryFee: '',
          packageUnit: '',
          price: '',
        },
      ],
    });
    const enableTargetDate = ref(false);

    const addItem = () => {
      client.items.push({
        id: -1,
        name: '',
        code: '',
        width: '',
        length: '',
        height: '',
        count: '',
        weight: '',
        unitsPerCount: '1',
        unit: '',
        deliveryFee: '',
        packageUnit: '',
        price: '',
      });
    };
    const deletedPackages: Ref<number[]> = ref([]);
    const createdPackages = computed(() => client.items.filter((item: any) => (
      item.id === -1
    )).map((item: any) => ({
      ...item,
      id: undefined,
      width: parseFloat(item.width),
      length: parseFloat(item.length),
      height: parseFloat(item.height),
      volume: parseFloat(item.width) * parseFloat(item.length) * parseFloat(item.height) || 0,
      weight: parseFloat(item.weight),
      count: parseInt(item.count, 10),
      unitsPerCount: parseFloat(item.unitsPerCount),
      deliveryFee: parseFloat(item.deliveryFee),
      price: parseFloat(item.price),
      deliveryFeeRate: undefined,
    })));
    const updatedPackages = computed(() => client.items.filter((item: any) => (
      item.id !== -1
    )).map((item: any) => ({
      ...item,
      width: parseFloat(item.width),
      length: parseFloat(item.length),
      height: parseFloat(item.height),
      volume: parseFloat(item.width) * parseFloat(item.length) * parseFloat(item.height) || 0,
      weight: parseFloat(item.weight),
      count: parseInt(item.count, 10),
      unitsPerCount: parseFloat(item.unitsPerCount),
      deliveryFee: parseFloat(item.deliveryFee),
      price: parseFloat(item.price),
      deliveryFeeRate: undefined,
    })));
    const pop = (index: number) => {
      deletedPackages.value.push(client.items[index].id);
      client.items.splice(index, 1);
    };

    const computedTotalDeliveryFee = computed(() => {
      if (client.items.length === 0) return 0;
      const res = client.items.reduce((a: any, b: any) => parseFloat(a + parseFloat(b.deliveryFee)), 0) - parseFloat(client.deliveryDiscount);
      if (res >= 0) return res;
      return 0;
    });
    const computedPackagesInput = computed(() => client.items.map((item: any) => ({
      ...item,
      id: undefined,
      width: parseFloat(item.width) || 0,
      length: parseFloat(item.length) || 0,
      height: parseFloat(item.height) || 0,
      volume: parseFloat(item.width) * parseFloat(item.length) * parseFloat(item.height) || 0,
      weight: parseFloat(item.weight) || 0,
      count: parseInt(item.count, 10),
      unitsPerCount: parseInt(item.unitsPerCount, 10) || 0,
      deliveryFee: parseFloat(item.deliveryFee),
      price: parseFloat(item.price),
      deliveryFeeRate: undefined,
    })));
    const orderInput = computed(() => ({
      orderDate: `${useFormat.date(client.orderDate).computerShortDate()} ${client.orderTime}`,
      orderTime: undefined,
      customerCode: client.customerCode,
      customerName: client.name,
      contactName: client.contact,
      orderNumber: client.orderNo,
      deliveryDiscount: parseFloat(client.deliveryDiscount),
      address: {
        ...client.address,
        address: client.address.address,
        province: client.address.province.id,
        district: client.address.district.id,
        subdistrict: client.address.subdistrict.id,
        zipcode: `${client.address.zipcode}`,
      },
      senderName: client.senderName,
      senderCode: client.senderCode,
      contactTelephone: client.tel,
      senderAddress: {
        senderAddress: client.senderAddress.address !== '' ? client.senderAddress.address : undefined,
        senderProvince: client.senderAddress.province.id !== '' ? client.senderAddress.province.id : undefined,
        senderDistrict: client.senderAddress.district.id !== '' ? client.senderAddress.district.id : undefined,
        senderSubdistrict: client.senderAddress.subdistrict.id !== '' ? client.senderAddress.subdistrict.id : undefined,
        senderZipcode: `${client.senderAddress.zipcode}`,
      },
      // deliveryArea: client.orderZone,
      area: (client.area as any)?.id ? { connect: (client.area as any)?.id } : undefined,
      deliveryFee: computedTotalDeliveryFee.value,
      paymentType: client.payment,
      remarks: client.notation,
      lat: parseFloat(client.lat || '0.0'),
      long: parseFloat(client.long || '0.0'),
      status: props.edit ? undefined : 'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER',
      packages: {
        create: computedPackagesInput.value,
      },
      targetDate: enableTargetDate.value ? client.targetDate : undefined,
    }));

    const refetchQueries = ['getDeliveries', 'getDeliveryNotes', 'getDelivery'];
    const createOrderMutation = useMutation(createDelivery, () => ({
      variables: {
        input: orderInput.value,
      },
      refetchQueries,
    }));

    const { route } = useRouter();
    // const oldOrder = ref({});
    const { result: getOldOrderResult, loading } = useQuery(getDelivery, computed(() => ({
      id: route.value.params.id,
    })));
    const oldOrderResult = useResult(getOldOrderResult, {}, (data) => data.delivery);
    watch(() => oldOrderResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal && props.edit) {
        const orderDateTime = new Date(oldOrderResult.value.orderDate);
        client.id = oldOrderResult.value.id;
        client.name = oldOrderResult.value.customerName;
        client.customerCode = oldOrderResult.value.customerCode;
        client.orderDate = orderDateTime;
        client.orderTime = orderDateTime.toTimeString().substr(0, 8);
        client.contact = oldOrderResult.value.contactName;
        client.orderNo = oldOrderResult.value.orderNumber;
        client.deliveryDiscount = oldOrderResult.value.deliveryDiscount;
        client.address = {
          address: oldOrderResult.value.address.address || '',
          province: oldOrderResult.value.address.province || { id: null },
          district: oldOrderResult.value.address.district || { id: null },
          subdistrict: oldOrderResult.value.address.subdistrict || { id: null },
          zipcode: oldOrderResult.value.address.zipcode,
          telephone: oldOrderResult.value.address.telephone,
        };
        client.tel = oldOrderResult.value.contactTelephone;
        client.senderName = oldOrderResult.value.senderName;
        client.senderCode = oldOrderResult.value.senderCode;
        client.senderAddress = {
          address: oldOrderResult.value.senderAddress.address,
          province: oldOrderResult.value.senderAddress.province || { id: null },
          district: oldOrderResult.value.senderAddress.district || { id: null },
          subdistrict: oldOrderResult.value.senderAddress.subdistrict || { id: null },
          zipcode: oldOrderResult.value.senderAddress.zipcode !== 'null' ? oldOrderResult.value.senderAddress.zipcode : '',
        };
        client.area = oldOrderResult.value.area?.id;
        client.price = oldOrderResult.value.deliveryFee;
        client.payment = oldOrderResult.value.paymentType;
        client.notation = oldOrderResult.value.remarks;
        client.items = oldOrderResult.value.packages.map((item: any) => ({
          id: item.id,
          name: item.name,
          code: item.code,
          width: item.width,
          length: item.length,
          height: item.height,
          count: item.count,
          weight: item.weight,
          unitsPerCount: item.unitsPerCount,
          unit: item.unit,
          deliveryFee: item.deliveryFee,
          deliveryFeeRate: toDecimalFormat(item.deliveryFee / item.count),
          packageUnit: item.packageUnit,
          price: item.price,
        }));
        client.lat = oldOrderResult.value.lat;
        client.long = oldOrderResult.value.long;
        client.area = oldOrderResult.value.area;

        if (oldOrderResult.value.targetDate && oldOrderResult.value.targetDate !== null && oldOrderResult.value.targetDate !== '') {
          client.targetDate = oldOrderResult.value.targetDate;
          enableTargetDate.value = true;
        }
      }
    });

    const editOrderMutation = useMutation(updateDelivery, () => ({
      variables: {
        input: {
          ...orderInput.value,
          id: route.value.params.id,
          packages: {
            delete: deletedPackages.value,
            create: createdPackages.value,
            update: updatedPackages.value,
          },
        },
      },
      refetchQueries,
    }));

    const computedMutation = computed(() => (
      props.edit ? editOrderMutation : createOrderMutation
    ));
    const confirmModal = ref(null);
    createOrderMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'รายการส่ง สำเร็จ' });
    });
    editOrderMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'รายการส่ง สำเร็จ' });
    });
    const errorModal = ref(null);
    createOrderMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    editOrderMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    return {
      paymentMethodTH,
      paymentMethodEN,

      client,
      addItem,
      pop,

      computedMutation,
      confirmModal,
      errorModal,

      deletedPackages,
      createdPackages,
      updatedPackages,

      computedTotalDeliveryFee,
      enableTargetDate,
    };
  },
});

export default CommonFormWithDeliveryEditor;
